// Utils
import { isFeatureEnabled as isStaticFeatureEnabled } from '@shopee-user/static-feature-toggle';
import { Monitor } from './monitor';
import { mdapHook } from './performance/utils';

export { appTimingUtil } from './performance/utils';

// Constants
import { Feature as StaticFeature } from '@shopee-user/static-feature-toggle';

export const monitor = new Monitor();

async function initApmsWebJsErrorMonitoring() {
  if (
    isStaticFeatureEnabled(StaticFeature.EnableAPMSWebJsErrorMonitoring, false)
  ) {
    if (__APMS_APP_ID__ && __APMS_APP_SECRET_KEY__) {
      try {
        const { initApms } = await import(
          /* webpackChunkName: "apms"  */ './apms'
        );

        initApms(monitor, {
          appId: __APMS_APP_ID__,
          apmsSecretKey: __APMS_APP_SECRET_KEY__,
          bundleName: __BUSINESS_TARGET__,
          bundleVersion: __APMS_APP_RELEASE__,
          buildId: __APMS_APP_BUILD_ID__,
          locale: __LOCALE__,
          env: __ENV__,
        });
      } catch (err) {
        console.error('failed to init APMS SDK', err.message || err.toString());
      }
    } else {
      console.warn(
        '[APMS] SDK is not initialized because of missing appId or secretKey, skipping APMS web js error monitoring'
      );
    }
  }
}

async function initMdapPerformanceMonitoring() {
  if (
    isStaticFeatureEnabled(StaticFeature.EnableMDAPPerformanceMonitoring, false)
  ) {
    try {
      const { initMdapMonitoring } = await import(
        /* webpackChunkName: "mdap"  */ './mdap'
      );

      initMdapMonitoring(monitor, {
        appName: __MDAP_APP_NAME__,
        secretKey: __MDAP_APP_SECRET_KEY__,
        region: __LOCALE__,
        onTransformTrackingPointId: mdapHook.onTransformTrackingPointId,
        onBeforeSendCustomData: mdapHook.onBeforeSendCustomData,
      });
    } catch (err) {
      console.error('failed to init MDAP SDK', err.message || err.toString());
    }
  }
}

export function initMonitoring() {
  initApmsWebJsErrorMonitoring();
  initMdapPerformanceMonitoring();
}
